.capacitytransferform__date__datepicker {
  width: 100%;
}
.capacitytransferform__buyerid__select {
  width: 100%;
}
.capacitytransferform .ant-form-item {
  margin-bottom: 0;
}
.capacitytransferform__buyerid__dropdown .ant-select-dropdown-menu-item .eic {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
